import '../../navigation/menu/Menu.css';
import './HelpMenu.css';
export var versionItem = '_zux1an0-3-15-1';
export var versionText = '_zux1an1-3-15-1';